'use strict';
var PZViews = function PZViews(props) {
    return React.createElement(
        React.Fragment,
        null,
        props.pzViews.length > 0 && React.createElement(
            'ul', {
                className: 'pz-thumbnail-items'
            },
            props.pzViews.map(function(view, index) {
                return React.createElement(
                    'li', {
                        key: index,
                        className: props.pzCurrentView == view.id ? 'pz-thumbnail-item side_' + view.id + ' active' : 'pz-thumbnail-item side_' + view.id,
                        onClick: function onClick(e) {
                            e.preventDefault(), props.pzChangeView(view.id);
                        }
                    },
                    React.createElement('canvas', {
                        id: 'thumbView_' + view.id,
                        className: 'img-responsive thumb-canvas'
                    }),
                    React.createElement(
                        'div', {
                            className: 'pz-thumbnail-detail'
                        },
                        React.createElement(
                            'span', {
                                className: 'pz-thumbnail-name'
                            },
                            view.view_name
                        )
                    )
                );
            })
        )
    );
};
